export function processAttachment(attachment) {
    if ([".gltf", ".glb"].some(ext => attachment.title.endsWith(ext))) {
        return { __type: "3d_model", ...attachment };
    }
    if (attachment.mimeType === "application/pdf") {
        return { __type: "pdf", ...attachment };
    }
    if (attachment.mimeType.toLowerCase().startsWith("image")) {
        return { __type: "image", ...attachment };
    }
    return { __type: "file", ...attachment };
}
export const isImage = (attachment) => attachment.__type === "image";
export const isPdf = (attachment) => attachment.__type === "pdf";
export const isFile = (attachment) => attachment.__type === "file";
export const is3dModel = (attachment) => attachment.__type === "3d_model";
export const isImageOr3dModel = (attachment) => attachment.__type === "image" || attachment.__type === "3d_model";
export const isPdfOrFile = (attachment) => attachment.__type === "pdf" || attachment.__type === "file";
//# sourceMappingURL=helpers.js.map